import { j as t } from "./index58.mjs";
import { CheckIcon as i } from "./index59.mjs";
import { BsExclamation as r } from "./index72.mjs";
import { showNotification as a, updateNotification as s } from "./index108.mjs";
class u {
  static success(o) {
    return a({
      message: o,
      color: "green",
      icon: /* @__PURE__ */ t.jsx(i, { className: "w-5 h-5" })
    });
  }
  static error(o) {
    return a({
      message: o,
      color: "red",
      icon: /* @__PURE__ */ t.jsx(r, { className: "w-5 h-5" })
    });
  }
  static loading(o) {
    return a({
      id: "loading-notification",
      message: o,
      color: "gray",
      loading: !0,
      autoClose: !1,
      disallowClose: !0
    });
  }
  static done(o) {
    return s({
      id: "loading-notification",
      message: o,
      color: "gray",
      icon: /* @__PURE__ */ t.jsx(i, { className: "scale-[0.69] translate-x-[-1px] translate-y-[-1px]" }),
      autoClose: 2e3
    });
  }
}
export {
  u as notification
};
